<div *ngIf="!isMobile" class="tabs-nav" fxFlex="20%" fxFlex.mm-tablet="30%" fxLayout="column nowrap">
  <ng-container *ngFor="let tab of tabs">
    <a
      [fragment]="tab?.fragment"
      [ngClass]="{ 'tabs-nav__link--active': activeFragment === tab?.fragment }"
      [routerLink]="['./']"
      class="tabs-nav__link"
    >
      {{ 'SELLER.SELLER_PAGE.' + tab?.fragment + '_TAB.TITLE' | uppercase | translate }}
    </a>
  </ng-container>
</div>
<div *ngIf="!isMobile; else mobilePanels" class="tabs-nav__content" fxFlex="1 1 80%">
  <ng-container *ngFor="let tab of tabs">
    <app-storefront-tab
      *ngIf="tab?.fragment === activeFragment"
      [@fadeInOut]
      [content]="tab?.content"
      [tabId]="tab?.fragment"
      [title]="'SELLER.SELLER_PAGE.' + tab?.fragment + '_TAB.TITLE' | uppercase | translate"
    >
    </app-storefront-tab>
  </ng-container>
</div>

<ng-template #mobilePanels>
  <div class="tabs-nav__content" fxFlex="1 1 auto">
    <ng-container *ngFor="let tab of tabs">
      <mm-expansion
        [arrowToggler]="true"
        [expanded]="activeFragment === tab?.fragment"
        (toggled)="setActiveTab(tab.fragment)"
      >
        <mm-expansion-title>
          <p>
            {{ 'SELLER.SELLER_PAGE.' + tab?.fragment + '_TAB.TITLE' | uppercase | translate }}
          </p>
        </mm-expansion-title>
        <app-storefront-tab
          [content]="tab?.content"
          [tabId]="tab?.fragment"
          [title]="'SELLER.SELLER_PAGE.' + tab?.fragment + '_TAB.TITLE' | uppercase | translate"
        >
        </app-storefront-tab>
      </mm-expansion>
    </ng-container>
  </div>
</ng-template>
